import React, { Dispatch, SetStateAction, useEffect, useRef } from 'react';
import { Typography } from 'gd-design-library';
import classNames from 'classnames/bind';
import styles from './SavedCreditCard.module.scss';
import { CreatePaymentWidgetParams, MountableElement, PAYMENT_METHODS, StoredPaymentMethodData } from 'integrations/payment';

interface SavedCreditCardProps {
  storedPaymentMethods : StoredPaymentMethodData[];
  setIsSavedPaymentDataValid : Dispatch<SetStateAction<boolean>>;
  createPaymentWidget: (params: CreatePaymentWidgetParams) => Promise<MountableElement>;
}

const cx = classNames.bind(styles);
const CN = 'saved-credit-card';
const cardClassName = `${CN}__card`;
const cardNameClassName = `${CN}__card-name`;

export const SavedCreditCard: React.FC<SavedCreditCardProps> = ({
  storedPaymentMethods,
  setIsSavedPaymentDataValid,
  createPaymentWidget
}) => {
  const storedPaymentContainer = useRef<HTMLDivElement>(null);

  const createCheckout = async (): Promise<void> => {
    const onChange = (isValid: boolean): void => {
      setIsSavedPaymentDataValid(isValid);
    };

    const widget = await createPaymentWidget({
      paymentMethodType: PAYMENT_METHODS.SavedCard,
      onChange
    });
    if (storedPaymentContainer.current) {
      widget.mount(storedPaymentContainer.current);
    }
  };

  useEffect(() => {
    createCheckout();
  }, []);

  return (
    <div className={ cx(CN) }>
      <Typography className={ cx(cardClassName) }>
        <span className={ cx(cardNameClassName) }>
          {storedPaymentMethods[0].name}
        </span> ends with {storedPaymentMethods[0].lastFour }
      </Typography>
      <div ref={ storedPaymentContainer }></div>
    </div>
  );
};
